import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-full flex content-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-2xl" }, "404", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg mt-4" }, "Page not found!", -1)
const _hoisted_4 = { class: "primary-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("button", _hoisted_4, [
      _createVNode(_component_router_link, { to: "/dashboard/teams" }, {
        default: _withCtx(() => [
          _createTextVNode("Take me somewhere better!")
        ]),
        _: 1
      })
    ])
  ]))
}